import api from '../api'

function levelDesc(info) {
  let levelDesc = ''
  if (info['user_honor']) {
    let level = +info['user_qa_level']
    let isTeacher = +info['is_consultant']
    if (isTeacher || level < 3) {
      levelDesc = `<span class="author-tag"><span>${info['user_honor']}</span></span>`
    } else {
      levelDesc = `<span class="honor-icon ${'honor-icon-' + level}"></span>`
    }
  }
  return levelDesc
}

function generateTitle(info, isToday) {
  let title
  if (isToday) {
    title = `今天发布了<span>${+info.star_total}</span>个星标回答`
  } else {
    let generateTitle = info.title
    let count = info.item_count
    title = (generateTitle + '').replace(/#item_count/, `<span>${count}</span>`)
  }
  return title
}

function createOperate(info, isToday) {
  let operateTpl
  if (isToday) {
    operateTpl = `
    <a href="" target="_blank">
      <div data-user-id="${info['user_id']}" class="rank-attention">
        <p class="unfollow ${info['is_follow'] ? 'hide' : ''}">
          <i class="yxlicon icon-icon-attention"></i>
        </p>
        <p class="follow ${info['is_follow'] ? '' : 'hide'}">
          <i class="yxlicon icon-icon-has-attentioned"></i>
        </p>
      </div>
    </a>
    `
  } else {
    operateTpl = `
      <div class="ques" data-user_id="${info.user_id}" data-nickname="${info.nickname}">
        <button>向ta提问</button>
      </div>
    `
  }
  return operateTpl
}

module.exports = function(data, isToday = false) {
  let rankList = ''
  data.forEach((item, index) => {
    rankList += `
      <li class="rank-item" data-teacher="${
        item['is_consultant']
      }"  data-user-id="${item['user_id']}">
        <div class="rank-number">
          ${
            index
              ? index + 1
              : '<img class="rank-champion" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAsCAYAAAB2d9g5AAAAAXNSR0IArs4c6QAAA5RJREFUWAntVs9LVUEU/ub67AUqVGqRQqBR1q4fGFpIEEQhKqEtqk2rFlGrqJ3uWkf/QptWRaEgRUGUoUaYiwqSqBahks8nRZmZ+qZzZu59b+7c++69r8Q2Hpj3zpzznfPdmXvuzBEwRPbXSGOqVNE1KzxbmJ99cRjT73jJ1up/nXDVd3p9S9e3tOQd+M9F4zhHIMQ9euxcyY8eDMipXJzTkJShQ3TMDNO8Ww7U7gLkFUhx3vQn08UChLxFJ+wN0Zl5b8f4CD2nC7woB+r6PFvif1G+Q3ROzRbDR77DQKAQgSembfPZAjEWcyShhQU6Lu2BcLqJZFgP0tlWguTvuqgYOVi7HzlxCjLXRu+mHhJ1Ci8wRe96kh5iCI68L9oz41F52BdJSMVzGlJeJ1xTXCLXP0Er76UauFMMH0ooH25rwGLuNj19S7HAaLsYRdo5J058+WTjAoTURhylhd8lsmobXNpcZClHD7UXT804H6EiE3hE76jcBP21LrBEuY6bpHlCdxtfJlpZ9WH9DFk+J+KEVpp2mr3tLXwW+p0l28bdVwEeiYRejcqtwYpQVWPSAtl8CKihr4MH64lEtmgOQK9Ql36iUDRdK+BMvWAN11wOoT7qZfkqHGVZNx0E2h74jUMnga9jfluxWUocSKkThEopVDZsASoa3bET2N4ehO27CUwPAvMfaHzU4/dcEMcWOq1S+riy/FV0PLbSp5jeajlCpozlYcriDDDSA3x/Z1rpA8i10Tuks9EWBo5fBlZ+2Z74OcdwrE2mIkW9kz+I7VSZJ8CLs8DyT9tTfM5YjuHYMKFDX1dpmJNt2eeU4AyR/iiGKNgZw1iOKSpSOnRf0BUTIXMjwNu+CIDretMLMDZKhJimFdJ9FidcrXGSTnJIyUlaIV2ecVK1Nw5BlZoAQ1wO39Sx2eyyz47Su6Jhio0xfZ5OXI7bFkx4tuA/7XoldY0s317rKhzuBHhwRbKNRWEia3CCuTSC2gIdFfJb2QgsfAbGLgDPjgEzjwsg1tnGPsZUNBR8tuZyFO7D/loqsZCWoqyCjiT6mOWKncI/F2V0FWykw2Leb1czMSq6Mq2s6hWyRj0InTpZVn3CCeLIOIAx4WR8AVNuLXlCfSPLHvoulzznP/+rXNTXGM1UnpCTq96DepDQlZbMTrtl9TOcwkfIBkVKPQhpVt2zN6moNrHZbJ68yHzReAbzf80aYZOU9dVs9f8ADow1MGOpLU0AAAAASUVORK5CYII=" alt="第一名"></img>'
          }
        </div>
        <div class="rank-avatar">
          <a href="${api.host + '/user/' + item['user_id']}" target="_blank">
            <img src="${
              item.avatar
                ? item.avatar
                : 'http://image.xinli001.com/images/avatar.jpg'
            }" alt="${item.nickname}">
          </a>
        </div>
        <div class="rank-info">
          <p class="rank-info-author">
            <a class="rank-info-name" href="${api.host +
              '/user/' +
              item['user_id']}" target="_blank">
              ${item.nickname}
            </a>
            ${levelDesc(item)}
          </p>
          <p class="rank-info-number">
            ${generateTitle(item, isToday)}
          </p>
          <p class="rank-info-merit">${item['brief']}</p>
        </div>
        ${createOperate(item, isToday)}
      </li>
    `
  })
  return rankList
}



// WEBPACK FOOTER //
// ./src/pages/ask/rankingList/render/rankList.js